module.exports = __webpack_public_path__ + "img/step_build.d6fb721c.png";